"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offline = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function Offline() {
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'Offline_Container', children: [(0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Offline, "data-e2e": 'Offline_StyledIcon' }), (0, i18n_1.Localized)(i18n_1.Strings.store.offline)] }));
}
exports.Offline = Offline;
const Container = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  margin: auto 0 20px 0;

  color: #bebebe;
  font-size: 14px;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 16px;
  height: 16px;
  margin-right: 5px;

  color: ${props => props.theme.lightGrey};
`;
